import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fe3eda3a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=fe3eda3a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3eda3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe3eda3a')) {
      api.createRecord('fe3eda3a', component.options)
    } else {
      api.reload('fe3eda3a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fe3eda3a&scoped=true", function () {
      api.rerender('fe3eda3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/agreement/index.vue"
export default component.exports